import React from 'react';
import { offerRows } from '../data/content';
import { CtaButton } from './CtaButton';
export function Offer() {
  return <section id="offer" className="w-full bg-white px-5 py-20 sm:py-28" data-id="element-128" data-mp="17xuswfmwwmsb">
      <div className="mx-auto max-w-md" data-id="element-129" data-mp="1mo2182j7gpfa">
        <h2 className="text-center font-display text-[1.6rem] font-black uppercase leading-tight tracking-tight text-brand sm:text-[2.2rem]" data-id="element-130" data-mp="1mmqz075erpqa">
          Special Launch Offer
        </h2>

        <div className="relative mt-10 rounded-3xl border-2 border-brand bg-white px-7 pb-8 pt-11 shadow-soft" data-id="element-131" data-mp="tzmsfxqo33ce">
          <span className="absolute -top-3 left-1/2 -translate-x-1/2 rounded-full bg-brand px-4 py-1.5 font-display text-[10px] font-extrabold uppercase tracking-[0.14em] text-lime" data-id="element-132" data-mp="p1l7t8dlevyt">
            Tennis Ready Pack
          </span>

          <dl data-id="element-133" data-mp="2fc68gshfdak3">
            {offerRows.map(row => <div key={row.label} className="flex items-center justify-between border-b border-brand/10 py-4 text-sm" data-id="element-134" data-mp="2famsl2zol1iu">
                <dt className="text-ink/80" data-id="element-135" data-mp="pl0e3yahc2fz">{row.label}</dt>
                <dd className="font-bold text-brand" data-id="element-136" data-mp="pml8nnwsnldu">{row.value}</dd>
              </div>)}
            <div className="flex items-center justify-between border-b border-brand/10 py-4 text-sm" data-id="element-137" data-mp="ul4y3yaljfay">
              <dt className="font-bold uppercase tracking-wide text-ink" data-id="element-138" data-mp="zgk4y6a6saxv">
                Total Value
              </dt>
              <dd className="font-bold text-ink/40 line-through" data-id="element-139" data-mp="6u9918xiyy7e">$232 USD</dd>
            </div>
          </dl>

          <p className="mt-6 text-center font-display text-[11px] font-extrabold uppercase tracking-[0.16em] text-lime-dark" data-id="element-140" data-mp="bs1060qcigaj">
            Today Only
          </p>
          <p className="flex items-center justify-center gap-2 border-b border-brand/10 pb-7 pt-2" data-id="element-141" data-mp="fsku6vfmh3sg">
            <span className="font-display text-6xl font-black leading-none text-brand" data-id="element-142" data-mp="kmyyjnc9il99">
              $27
            </span>
            <span className="self-end pb-2 text-sm font-bold text-lime-dark" data-id="element-143" data-mp="3o9pf9cb83r1o">
              USD
            </span>
          </p>

          <CtaButton className="mt-7 w-full" data-id="element-144" data-mp="vefta29km513" />

          <p className="mt-4 text-center text-[11px] font-medium text-ink/50" data-id="element-145" data-mp="qgnr8ff7p2j6">
            Instant Download • One-Time Payment • Lifetime Access • 7-Day
            Guarantee
          </p>
        </div>
      </div>
    </section>;
}